import { createRouter, createWebHistory } from "vue-router";
import Home from "./views/HomeView.vue";

export const shareRouter = createRouter({
  history: createWebHistory(),
  routes: [
    // Different menus
    {
      path: "/:shareId",
      name: "home",
      component: Home,
      props: true
    },
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: () => import("./views/NotFound.vue")
    }
  ]
});
